import React, { useEffect, useState } from 'react';
import { Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';

const ProyectoList = () => {
  const [proyectos, setProyectos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/proyectos/').then(res => setProyectos(res.data));
  }, []);

  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5">Proyectos</Typography>
        <Button variant="contained" onClick={() => navigate('/proyectos/nuevo')}>Nuevo Proyecto</Button>
      </Box>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Sector</TableCell>
              <TableCell>Programa</TableCell>
              <TableCell>Activo</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {proyectos.map(proy => (
              <TableRow key={proy.id_proyecto}>
                <TableCell>{proy.codigo}</TableCell>
                <TableCell>{proy.descripcion}</TableCell>
                <TableCell>{proy.sector?.descripcion}</TableCell>
                <TableCell>{proy.programa?.descripcion}</TableCell>
                <TableCell>{proy.activo ? 'Sí' : 'No'}</TableCell>
                <TableCell>
                  <Button size="small" variant="outlined" onClick={() => navigate(`/proyectos/${proy.id_proyecto}`)}>
                    Editar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default ProyectoList;